
$(document).on('turbolinks:load', function () {
  document.querySelectorAll('.column').forEach(function(element) {
    if ($(element).height() <= 18 && $(element).parent('.data-non-conformity').height() > 40) element.style.marginTop = "1%"
  })
})
